// extracted by mini-css-extract-plugin
export var accordion = "_dr-0";
export var chevron = "_dr-3";
export var closed = "_dr-2";
export var content = "_dr-4";
export var open = "_dr-1";
export var rotate = "_dr-5";